export default "__VITE_ASSET__B$JqrLA8__"